import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=3dc882f6&scoped=true&"
import script from "./ReportCard.vue?vue&type=script&lang=js&"
export * from "./ReportCard.vue?vue&type=script&lang=js&"
import style0 from "../UploadReportDialog.css?vue&type=style&index=0&id=3dc882f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc882f6",
  null
  
)

export default component.exports